import React, { Component } from "react";
import Props from "./Props";

class AlignItems extends Component {
  state = {
    property: "align-items",
    definition:
      "The CSS align-items property sets the align-self value on all direct children as a group. In Flexbox, it controls the alignment of items on the Cross Axis.",
    defaultOption: "flex-start",
    options: ["flex-start", "flex-end", "center", "baseline", "stretch"],
    flexContainer: { fcHeight: "400px", fcWidth: "600px" },
    flexItems: [
      { label: 1, itemHeight: "160px", itemWidth: "200px" },
      { label: 2, itemHeight: "100px", itemWidth: "100px" },
      { label: 3, itemHeight: "120px" },
      { label: 4, itemHeight: "200px", itemWidth: "120px" },
    ],
  };

  render() {
    const { state } = this;

    return <Props {...state} />;
  }
}

export default AlignItems;
